import { memo } from "react";
import { DragDropContext, Droppable, OnDragEndResponder } from "react-beautiful-dnd";
import { tokens } from "styles/Tokens";
import DraggableListItem from "./DraggableListItem";

interface Item {
  id: string;
  name: string;
}

interface DraggableListProps {
  items: Item[];
  onDragEnd: OnDragEndResponder;
}

const DraggableList = memo(({ items, onDragEnd }: DraggableListProps) => {
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable-list">
        {(provided, snapshot) => (
          <div
            style={{
              backgroundColor: snapshot.isDraggingOver ? tokens.Draggable.General.Border : "unset",
              width: "100%",
              borderRadius: "5px"
            }}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {items?.map((item, index) => (
              <DraggableListItem item={item} index={index} key={item.id} length={items.length} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
});

export default DraggableList;
